/**
 * Registration mobile helpers — format, validate, and compare SA numbers
 * so 083 / 27 / +27 variants of the same MSISDN match.
 */

export function normalizePhone(raw: string): string {
  const s = (raw || '').replace(/\s+/g, '').replace(/[()-]/g, '');
  if (s.startsWith('+27')) return s.slice(1);
  if (s.startsWith('27')) return s;
  if (s.startsWith('0') && s.length === 10) return '27' + s.slice(1);
  return s;
}

export function isValidSAMobile(raw: string): boolean {
  const n = normalizePhone(raw);
  return /^27[6-8][0-9]{8}$/.test(n);
}

export function phonesMatch(a: string, b: string): boolean {
  if (!isValidSAMobile(a) || !isValidSAMobile(b)) return false;
  return normalizePhone(a) === normalizePhone(b);
}

/** Local display 0XX XXX XXXX once the number is a valid SA mobile. */
export function formatLocalWalletDisplay(raw: string): string {
  if (!isValidSAMobile(raw)) return '';
  const n = normalizePhone(raw);
  const local = `0${n.slice(2)}`;
  return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
}

/** As-you-type grouping for 0 / 27 / +27 SA mobiles. */
export function formatPhoneNumber(value: string): string {
  const cleaned = value.replace(/[^\d+]/g, '');
  if (cleaned.startsWith('+27')) {
    const digits = cleaned.slice(3);
    if (digits.length <= 9) {
      if (digits.length >= 3) {
        return `+27 ${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`.trim();
      }
      return `+27 ${digits}`;
    }
  } else if (cleaned.startsWith('27')) {
    const digits = cleaned.slice(2);
    if (digits.length <= 9) {
      if (digits.length >= 3) {
        return `27 ${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`.trim();
      }
      return `27 ${digits}`;
    }
  } else if (cleaned.startsWith('0')) {
    const digits = cleaned.slice(1);
    if (digits.length <= 9) {
      if (digits.length >= 3) {
        return `0${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`.trim();
      }
      return `0${digits}`;
    }
  }
  return cleaned.slice(0, 13);
}
